import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
              {aboutInfo.title}
            </h2>
          </div>
          <div className="space-y-4 mb-8 md:mb-10">
            {aboutInfo.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
            {aboutInfo.stats.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60"
              >
                <div className="text-xl md:text-2xl font-bold font-heading text-accent-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}